<template>
  <CustomModal :is-modal="show" :closeOuth="true" :width="'xlg'" @closeModal="$emit('close')">
    <h5 class="modal-title text semi-bold">Incidencias que contaron</h5>

    <div v-if="mismatch" class="claims-mismatch">
      El detalle no cuadra con el total de la quincena, así que no se muestra. El nivel se calculó
      con <strong>{{ engineCount }}</strong> incidencias y gravedad acumulada
      <strong>{{ engineWeight }}</strong>.
    </div>

    <ContentMetrics v-if="claims">
      <Metric :value="displayCount" :title="'Incidencias'" :border="true" />
      <Metric :value="displayWeight" :title="'Gravedad acumulada'" :border="true" />
      <Metric :value="ordersCount" :title="'Pedidos'" :border="true" />
      <Metric :value="ratioLabel" :title="'Gravedad por pedido'" />
    </ContentMetrics>

    <div v-if="showDetail" class="mt-4 mb-4 content-table-level">
      <el-table :data="rows" row-key="id" header-row-class-name="thead-desing-dark" class="desing-dark">
        <el-table-column label="Fecha" prop="created_at" min-width="110px">
          <template v-slot="{ row }">{{ shortDate(row.created_at) }}</template>
        </el-table-column>
        <el-table-column label="Tipología" prop="typology" min-width="200px">
          <template v-slot="{ row }">{{ row.typology || 'Sin tipología' }}</template>
        </el-table-column>
        <el-table-column label="Severidad" prop="severity" min-width="120px">
          <template v-slot="{ row }">
            <span class="claims-severity" :style="severityStyle(row)">{{ row.severity || 'Sin severidad' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Gravedad" prop="weight" min-width="90px">
          <template v-slot="{ row }"
            ><strong>{{ row.weight }}</strong></template
          >
        </el-table-column>
      </el-table>
    </div>

    <p v-else-if="claims && !mismatch" class="claims-empty">Esta quincena no tuvo incidencias.</p>
  </CustomModal>
</template>

<script>
import { Table, TableColumn } from 'element-ui';
import CustomModal from '../../../components/CustomModal';
import ContentMetrics from '@/components/Levels/ContentMetrics';
import Metric from '@/components/Levels/Metric';

const DECIMALS = 2;
const DATE_LENGTH = 10;
const FALLBACK_SEVERITY_COLOR = '#8a988f';

export default {
  name: 'ClaimsModal',
  components: {
    CustomModal,
    ContentMetrics,
    Metric,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  props: {
    show: { type: Boolean, default: false },
    claims: { type: Object, default: null },
    mismatch: { type: Boolean, default: false },
    ordersCount: { type: Number, default: 0 }
  },
  computed: {
    rows() {
      return this.claims && Array.isArray(this.claims.claims) ? this.claims.claims : [];
    },
    showDetail() {
      return Boolean(this.claims) && !this.mismatch && this.rows.length > 0;
    },
    engineCount() {
      return this.claims && this.claims.engine ? this.claims.engine.claims_count : null;
    },
    engineWeight() {
      return this.claims && this.claims.engine ? this.claims.engine.claims_weight_sum : null;
    },
    displayCount() {
      return this.mismatch ? this.engineCount : this.rows.length;
    },
    displayWeight() {
      if (this.mismatch) {
        return this.engineWeight;
      }

      return this.claims ? this.claims.breakdown.claims_weight_sum : null;
    },
    ratioLabel() {
      if (!this.ordersCount) {
        return 'sin pedidos';
      }

      return (Number(this.displayWeight) / Number(this.ordersCount)).toFixed(DECIMALS);
    }
  },
  methods: {
    shortDate(value) {
      return value ? String(value).slice(0, DATE_LENGTH) : '';
    },
    severityStyle(row) {
      return { color: row.severity_color || FALLBACK_SEVERITY_COLOR };
    }
  }
};
</script>

<style lang="scss" scoped>
.claims-mismatch {
  border: 1px solid rgba(251, 176, 59, 0.5);
  background: rgba(251, 176, 59, 0.12);
  color: #a2681a;
  border-radius: 10px;
  padding: 12px 14px;
  margin: 1rem 0;
  font-size: 0.9rem;
}
.claims-severity {
  font-weight: 700;
}
.claims-empty {
  color: #8a988f;
  font-style: italic;
}
</style>
